export const getLoginErrorContent = (loginError) => {
  const normalizedErrorMessage =
    typeof loginError === "string"
      ? loginError
      : loginError?.message ||
        loginError?.error ||
        loginError?.data?.message ||
        loginError?.payload?.message ||
        "";

  if (!loginError) {
    return {
      header: "Password Incorrect",
      paragraph:
        "The password you entered is incorrect. Please try again or visit the recovery center to reset the password of your Veegil SSO.",
      buttonText: "Account Recovery",
      recoveryPath: "/account-recovery/password-recovery",
    };
  }

  // Check if it's a server error (500) or contains server error indicators
  const isServerError =
    normalizedErrorMessage.includes("500") ||
    normalizedErrorMessage.includes("Server error") ||
    normalizedErrorMessage.includes("Internal server error") ||
    normalizedErrorMessage === "Login failed";

  if (isServerError) {
    return {
      header: "Server Error",
      paragraph:
        "We're experiencing technical difficulties. Please try again in a few moments. If the problem persists, contact support.",
      buttonText: "Try Again",
      recoveryPath: null,
    };
  }

  // For other authentication errors, show password incorrect message
  return {
    header: "Authentication Failed",
    paragraph:
      normalizedErrorMessage ||
      "The password you entered is incorrect. Please try again or visit the recovery center to reset the password of your Veegil SSO.",
    buttonText: "Account Recovery",
    recoveryPath: "/account-recovery/password-recovery",
  };
};
